import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromModels from '../../models/rootState.model';

export const selectInternetState = createFeatureSelector<fromModels.InternetState>('internet');
export const selectInternetOnline = createSelector(selectInternetState, (state) => state.online);
export const selectInternetLastChange = createSelector(selectInternetState, (state) => state.lastChange);

